import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IFeatureSetDetailsStyles {
  root?: IStyle;
  list?: IStyle;
  description?: IStyle;
}

export interface IFeatureSetDetailsClassNames {
  root: string;
  list: string;
  description: string;
}

export const featureSetDetailsStylesDefault = (theme: IH2OTheme): Partial<IFeatureSetDetailsStyles> => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
  description: {
    color: theme.semanticColors?.textSecondary,
    marginTop: 8,
    marginBottom: 8,
  },
  list: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  },
});
